import transitionPath from 'router5-transition-path'
import { findRoutes }  from '../utils'

import snackbarActions from '../../store/modules/snackbar'

import {
  AppRoute,
} from '../../../types/frontend/router'

import {
  RouteAuthenticateHandler,
  MiddlewareFactory,
} from '../../../types/frontend/router'

import {
  RootState,
} from '../../../types/frontend/store_generic'

/*

  run an authorize function on the route if present

  if the function returns a string - redirect there
  otherwise allow the route

*/

function AuthMiddlewareFactory<RootStateType extends RootState = RootState>() {
  const authorizeRoute: MiddlewareFactory<RootStateType> = (routes) => (router, dependencies) => (toState, fromState, done) => {
    const { toActivate } = transitionPath(toState, fromState)
    const { store } = dependencies

    const routeError = (message: string) => {
      console.error(message)
      store.dispatch(snackbarActions.setError(message))
      done(message)
    }

    const authorizeHandlers = findRoutes(routes as AppRoute<RootState>[], toActivate)
      .map(route => route.auth)
      .filter((auth): auth is RouteAuthenticateHandler => auth ? true : false)

    if(authorizeHandlers.length <= 0) return done()  
    if(authorizeHandlers.length > 1) return routeError(`multiple authorize settings found in route`)

    const authorizeHandler = authorizeHandlers[0]
    const redirectTo = authorizeHandler(store)

    if(!redirectTo) {
      done()
    }
    else {
      done({
        redirect: {
          name: redirectTo,
        },
      })
    }
  }

  return authorizeRoute
}

export default AuthMiddlewareFactory